import styled from "styled-components"
import { ImageWithLinkOrNot } from "../ImageWithLinkOrNot/"

export const Icon = styled(ImageWithLinkOrNot)`
  width: 2.5625em;
  height: 2.5625em;
  margin-right: 0.5em;
`
